import type { AxiosResponse } from "axios";
import axios from "axios";
import type { Configuration, SystemConfiguration } from "./types";
import { env } from "../../config";

// Variável para armazenar a promise pendente
let pendingPromise: Promise<SystemConfiguration[]> | null = null;

const getSystemConfiguration = async (): Promise<SystemConfiguration[]> => {
	// Se já tiver uma promise em andamento, aguarda
	if (!pendingPromise) {
		pendingPromise = axios
			.get(env.system.systemConfigurationURL)
			.then((response: AxiosResponse<SystemConfiguration[]>) => response.data)
			.finally(() => {
				pendingPromise = null;
			});
	}

	return pendingPromise;
};

const getFeatureFlags = async (): Promise<Configuration[]> => {
	const data = await getSystemConfiguration();
	const featureFlags = data.find((config) => config._id === "featureFlags");
	return Array.isArray(featureFlags?.data) ? featureFlags!.data : [];
};

const getFeatureFlag = async (key: string): Promise<boolean> => {
	const featureFlags = await getFeatureFlags();
	const flag = featureFlags.find((f) => f.key === key);
	return typeof flag?.value === "boolean" ? flag.value : false;
};

// Public API
export const getFeatureFlagLoginFgts = async (): Promise<boolean> => {
	try {
		return await getFeatureFlag("loginFgts");
	} catch {
		return false;
	}
};

export const getFeatureFlagPixInstallmentsUnavailable = async (): Promise<boolean> => {
	try {
		return await getFeatureFlag("pixInstallmentsUnavailable");
	} catch {
		return false;
	}
};

export const getFeatureFlagIsVisibleColdSimulationFGTS = async (): Promise<boolean> => {
	try {
		return await getFeatureFlag("isVisibleColdSimulationFTGS");
	} catch {
		return false;
	}
};

export const getFFfgtsBlackFriday = async (): Promise<boolean> => {
	try {
		return await getFeatureFlag("fgtsBlackFriday");
	} catch {
		return false;
	}
};

export const getFFFgtsSellersCode = async (): Promise<boolean> => {
	try {
		return await getFeatureFlag("fgtsSeller");
	} catch {
		return false;
	}
};

export const getFFSecondQiTechAccount = async (): Promise<boolean> => {
	try {
		return await getFeatureFlag("secondQiTechAccount");
	} catch {
		return false;
	}
};

export const getFFBigPayLuck = async (): Promise<boolean> => {
	try {
		return await getFeatureFlag("bigPayLuck");
	} catch (error) {
		return false;
	}
};

export const getFFIsDisableFGTS = async (): Promise<boolean> => {
	try {
		return await getFeatureFlag("isDisableFGTS");
	} catch (error) {
		return false;
	}
};
